import {LOGOUT} from "./skysso";
export const SPLASH_SCREEN_RESPONSE = "SPLASH_SCREEN_RESPONSE";

const defaultState = {
  siteLoad: null,
  login: null
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case SPLASH_SCREEN_RESPONSE:
      return {
        ...state,
        [action.trigger]: action.data
      };

    case LOGOUT:
      return defaultState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/splashpage.js